import { Subscriptions } from 'pages/personal-area/components/personalAreaTabsContent/subscriptions/Subscriptions'
import { FamilyAndFriends } from 'pages/personal-area/components/personalAreaTabsContent/familyAndFriends/FamilyAndFriends'
// import { MyMerch } from 'pages/personal-area/components/personalAreaTabsContent/myMerch/MyMerch'
import { PersonalDetails } from 'pages/personal-area/components/personalAreaTabsContent/personalDetails/PersonalDetails'
import { PurchaseHistory } from 'pages/personal-area/components/personalAreaTabsContent/purchasehistory/PurchaseHistory'
import TheRedClub from 'pages/personal-area/components/personalAreaTabsContent/theRedClub/TheRedClub'
import { EPersonalAreaTabs } from 'types/enums/EPersonalAreaTabs'
import { IPersonalAreaTab } from 'types/interfaces/IPersonalAreaTab'
import { Lobby } from 'pages/personal-area/components/personalAreaTabsContent/lobby/Lobby'

export const usePersonalTabsData = () => {
  const tabs: IPersonalAreaTab[] = [
    {
      title: {
        key: EPersonalAreaTabs.LOBBY,
        label: 'Lobby',
      },
      content: <Lobby />,
    },
    {
      title: {
        key: EPersonalAreaTabs.PERSONAL_DETAILS,
        label: 'Personal Details',
      },
      content: <PersonalDetails />,
    },
    {
      title: { key: EPersonalAreaTabs.SUBSCRIPTIONS, label: 'Subscriptions' },
      content: <Subscriptions />,
    },
    {
      title: {
        key: EPersonalAreaTabs.PURCHASE_HISTORY,
        label: 'Purchase History',
      },
      content: <PurchaseHistory />,
    },
    {
      title: {
        key: EPersonalAreaTabs.FAMILY_AND_FRIENDS,
        label: 'Family and Friends',
      },
      isComingSoon: false,
      content: <FamilyAndFriends />,
    },
    {
      title: { key: EPersonalAreaTabs.THE_RED_CLUB, label: 'The Red Club' },
      isComingSoon: true,
      content: <TheRedClub />,
    },
    // My Merchandise wont be available for now
    // {
    //   title: { key: EPersonalAreaTabs.MY_MERCHANDISE, label: 'My Merchandise' },
    //   isComingSoon: true,
    //   content: <MyMerch />,
    // },
  ]

  return tabs
}
